import React from 'react';

interface PageTemplateProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
}

export const PageTemplate: React.FC<PageTemplateProps> = ({
  title,
  description,
  children
}) => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">{title}</h1>
        {description && (
          <p className="text-muted-foreground mt-2">{description}</p>
        )}
      </div>
      
      <div className="rounded-lg border bg-card p-8 text-center">
        <div className="space-y-4">
          <div className="mx-auto h-12 w-12 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center">
            <div className="h-6 w-6 text-blue-600 dark:text-blue-400">🚧</div>
          </div>
          <div>
            <h3 className="text-lg font-medium">Coming Soon</h3>
            <p className="text-sm text-muted-foreground">
              This feature is being migrated from the old application.
            </p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};